module.exports = __webpack_public_path__ + "static/media/item_sli_freq_des.64762e07.png";